export default __webpack_public_path__ + "static/media/Cybersecurity_WebPage_banner_no_text.206c5097.jpg";